<template>

  <ui-card name="overview.transport_mode_overview" padded>
    <error-state type="placeholder" />
  </ui-card>

</template>

<script>
export default {
  name: 'TransportModeOverviewCard',
};
</script>

<style lang="scss" scoped>
</style>